import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { ActivityService } from '../../../services/activity/activity.service';
import { IndSectionHeaderViewDataModel } from '@omni/models/indSectionHeaderDataModel';
import { TranslateService } from '@ngx-translate/core';
import { PopoverController } from '@ionic/angular';
import { ListPreviewComponent } from '@omni/components/list-preview/list-preview.component';
import { EventsToolService } from '@omni/services/events-tool/events-tool.service';
import { CustomerAssessService } from '@omni/services/customer-assess/customer-assess.service';
import { ConsentService } from '@omni/services/consent/consent.service';
import { ContactOfflineService } from '@omni/services/contact/contact.service';
import { TimeLineItem } from '@omni/components/timeline-item/timeline-item.component';
import { AppointmentActivity } from '@omni/classes/activity/appointment.activity.class';
import { DateTimeFormatsService } from '@omni/services/date-time-formats/date-time-formats.service';
import { AuthenticationService } from '@omni/services/authentication.service';
import { FeatureActionsMap, IoConfigurationFeatureCodes } from '@omni/classes/authentication/user.class';
import { SampleActivity } from '@omni/classes/activity/sample.activity.class';
import { EmailActivity, EmailViewType } from '@omni/classes/activity/email.activity.class';
import { EmailService } from '@omni/services/email-templates/email.service';
import { PhoneActivity } from '@omni/classes/activity/phone.activity.class';
import { SurgeryOrderActivity } from '@omni/classes/activity/surgery-order.activity.class';
import { CaseActivity } from '@omni/classes/case-intake/case-activity.class';
import { EventActivity } from '@omni/classes/events-tool/event.class';
import { ConsentSource, ConsentTerm } from '@omni/classes/consent/consent-term.class';
import { ConsentActivity } from '@omni/classes/consent/consent-activity.class';
import { Activity, ActivityType, MeetingActivityState } from '@omni/classes/activity/activity.class';
import { SampleDeliveryRequestService } from '@omni/services/sample/sample-delivery-request.service';
import { NavigationService, PageName } from '@omni/services/navigation/navigation.service';
import { ComponentViewMode, UIService } from '@omni/services/ui/ui.service';
import { DynamicFormsService } from '@omni/services/dynamic-forms/dynamic-forms-service';
import { AccesingMode, CaseManagementService } from '@omni/services/case-management/case-management.service';
import { SampleService, SamplingDetailsViewMode } from '@omni/services/sample/sample.service';
import { ActivityDataService } from '@omni/data-services/activity/activity.service';
import { DeviceService } from '@omni/services/device/device.service';
import { EventsService } from '@omni/services/events/events.service';
import { FooterService, FooterViews } from '@omni/services/footer/footer.service';
import { CaseManagementDataService } from '@omni/data-services/case-management/case-management.data.service';
import { DB_KEY_PREFIXES } from '@omni/config/pouch-db.config';
import { EventRegistration } from '@omni/classes/customer-event/customer-event.class';
import { EventsToolDataService } from '@omni/data-services/event/events-tool.data.service';
import { NotificationService, ToastStyle } from '@omni/services/notification/notification.service';
import { AssessmentTemplate, SurveyCategory, SurveyFrequency, SurveyStatus, TemplateType } from '@omni/classes/customer-assessment/assessment-template.class';
import { CustomerSurveyService } from '@omni/services/customer-survey/customer-survey.service';
import { CustomerAssessment } from '@omni/classes/customer-assessment/customer-assessment.class';
import { Customer360UIService } from '@omni/services/ui/customer360ui.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { EventRegistrationStatus } from '@omni/enums/event/event.enum';
import { ContactDataService } from '@omni/data-services/contact/contact.data.service';
import { CustomerEventsDataService } from '@omni/data-services/customer-event/customer-events.data.service';
import { cloneDeep, groupBy, isEmpty, values } from 'lodash-es';

/**
 * Generated class for the ContactFeedComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'contact-feed',
  templateUrl: 'contact-feed.html',
  styleUrls: ['contact-feed.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactFeedComponent {

  public timelineSectionHeader: IndSectionHeaderViewDataModel;
  public timelineItems: Array<TimeLineItem> = [];
  @Input () modalView: any

  private isMeetingHideSubTypeFAEnabled: boolean = false;
  private ngDestroy$ = new Subject<boolean>();
  @Input() readOnly: boolean;

  public isDataLoading: boolean = false;
  public pageSize: number = 3; // default value

  constructor(
    private readonly contactService: ContactOfflineService,
    private readonly contactDataService: ContactDataService,
    private readonly activityService: ActivityService,
    private readonly eventsToolService: EventsToolService,
    private readonly customerAssessService: CustomerAssessService,
    private readonly consentService: ConsentService,
    private readonly translate: TranslateService,
    private readonly popoverController: PopoverController,
    private readonly dateTimeFormatService: DateTimeFormatsService,
    private readonly authService: AuthenticationService,
    private readonly emailService: EmailService,
    private readonly dynamicFormService: DynamicFormsService,
    private readonly caseService: CaseManagementService,
    private readonly sampleService: SampleService,
    public uiService: UIService,
    private readonly activityDataService: ActivityDataService,
    private readonly device: DeviceService,
    private readonly eventService: EventsService,
    private readonly navService: NavigationService,
    private readonly footerService: FooterService,
    private readonly caseDataService: CaseManagementDataService,
    private readonly eventsToolDataService: EventsToolDataService,
    private readonly notificationService: NotificationService,
    private readonly customerSurveyService: CustomerSurveyService,
    private readonly customer360UIService: Customer360UIService,
    public customerEventDataService: CustomerEventsDataService,
    private readonly cd: ChangeDetectorRef,
    private readonly sdrService: SampleDeliveryRequestService,
  ) {

  }

  trackById(index: number, item: any) { return item?.id || item?.ID || index; }
  trackByIndex(index: number) { return index; }

  ngOnInit() {
    this._initFA();
    this._initSectionHeadersView();
    this.setPageSize();
    // this._initTimelineItemsData();
    // this.device.isOffline ? this._initTimelineItemsData() : this.initOnlineTimelineData();
    this.initTimeLine();

    this.navService.childNavPopObserver.pipe(takeUntil(this.ngDestroy$)).subscribe(page => {
      // Dropped the getActiveChildNavViewPageName() == PageName.ContactDetailsComponent
      // requirement — this subscription only exists while THIS contact-feed instance is
      // alive (torn down in ngOnDestroy via ngDestroy$), so it's already correctly scoped
      // without also needing the global active-child-nav pointer to land on exactly
      // ContactDetailsComponent. That pointer doesn't reliably reflect this page when the
      // contact is reached through a nested IonNav (e.g. the Spotlight/My Customers contact
      // profile), so creating a Sample Delivery Request from there never refreshed this
      // Feed preview — the record only ever showed up via "View All", which does its own
      // independent fetch regardless of this check.
      if (page && (
        page == PageName.ActivitiesDetailsPaneComponent ||
        page == PageName.PhoneCallDetailsComponent ||
        page == PageName.SurgeryOrderDetailsComponent ||
        page == PageName.NewSampleActivityComponent ||
        page == PageName.EmailDetailsPageComponent ||
        page == PageName.CaseManagementDetailComponent ||
        page == PageName.SurveyDetailsComponent ||
        page == PageName.EventDetailsPageComponent ||
        page == PageName.ContactTimelinePageComponent ||
        page == PageName.ContactConsentCaptureComponent ||
        page == PageName.SampleDeliveryRequestDetailComponent ||
        page == PageName.NewSampleDeliveryRequestComponent
      )) {
        this.initTimeLine();
        this.cd.markForCheck();
      }
    })
  }

  initTimeLine(){
    this.device.isOffline ? this._initTimelineItemsData() : this.initOnlineTimelineData();
  }

  ngOnDestroy() {
    this.ngDestroy$.next(true);
    this.ngDestroy$.complete();
  }

  setPageSize() {
    const configValueRaw = this.authService.getIOConfigurationValue(IoConfigurationFeatureCodes.ORG_CONTACT_GA_ACTIVITYCOUNT);
    const configValue = Number(configValueRaw);
    if (!isNaN(configValue) && configValue >= 3) {
      this.pageSize = configValue >= 25 ? 25 : configValue;
    }
  }

  private _initFA() {
    this.isMeetingHideSubTypeFAEnabled = this.authService.hasFeatureAction(FeatureActionsMap.MEETING_HIDE_SUBTYPE);
  }

  private _initSectionHeadersView() {
    this.timelineSectionHeader = {
      id: 'contact-timeline-section',
      title: this.translate.instant('TIMELINE'),
      controls: [{
        id: 'opentimelinedetails',
        isDisabled: this.readOnly || this.device.isOffline,
        text: this.translate.instant('VIEW_ALL'),
        // iconName: "chevron-forward-outline",
        //icon: 'assets/imgs/arrow-right-grey.svg',
      }]
    }
  }

  onSectionHeaderControlClick(id: string) {
    if (id === 'opentimelinedetails') {
      this.uiService.timelineRefreshRequired = true;
      this.navService.pushChildNavPageWithPageTracking(PageName.ContactTimelinePageComponent,PageName.ContactTimelinePageComponent,PageName.ContactPageComponent);
    }
  }

  private async _initTimelineItemsData() {
    if(this.contactService.contactInformation.ID){
      this.timelineItems = [];
      let activities: Array<any> = await this._getLatestActivitiesForTimeline(25);
      if (activities && activities.length > 0) {
        activities.forEach(item => {
          let view = this.customer360UIService.getViewForJourneyItem(true, item, this.contactService.contactInformation.ID);
          if (view) {
            this.timelineItems.push(view);
          }
        })
      }
      this.cd.markForCheck();
    }
  }

  private async _getLatestActivitiesForTimeline(sliceEnd?: number): Promise<Array<any>> {
    let allItems = [];
    let result = [];
    // Appointment
    // Sample
    // Email
    // Phone Call
    // Surgery Order
    // Case Intake
    const contactID = this.contactService.contactInformation.ID;
    try {
      for(let i=0; i<this.activityService.activities.length ;i++){
        const a = this.activityService.activities[i];
        if(a instanceof AppointmentActivity){
          if(a.contacts && a.contacts.some(b=> b.ID == contactID) && a.status != 4){
            allItems.push(a);
          }
        }else if(a instanceof SampleActivity){
          if(a.contactID == contactID){
            allItems.push(a);
          }
        }else if(a instanceof EmailActivity){
          if(a.emailActivityParties && a.emailActivityParties.some(b=> b.indskr_contactid== contactID)){
            allItems.push(a);
          }
        }else if(a instanceof PhoneActivity){
          if(a.contacts && a.contacts.length > 0 && a.contacts.some(b=> b.ID == contactID)){
            allItems.push(a);
          }else if(a.rawContactAttendees && a.rawContactAttendees.some((b:any)=> b.indskr_contactid == contactID || b.ID == contactID)){
            allItems.push(a);
          }
        }else if(a instanceof SurgeryOrderActivity){
          if(a.customers && a.customers.some(b=> b.ID == contactID)  && a.status != 548910005){
            allItems.push(a);
          }
        }else if(a instanceof CaseActivity){
          if(a._case_contact_id == contactID){
            allItems.push(a);
          }
        }
      }
      allItems = allItems.sort((a, b) => {
        if (a.scheduledStart > b.scheduledStart) return -1;
        if (a.scheduledStart < b.scheduledStart) return 1;
        return 0;
      }).slice(0, sliceEnd);
    } catch (error) {
      console.error('Error getting activities for timeline', error);
    }

    // Event
    try {
      if (this.eventsToolService.eventsToolData && this.eventsToolService.eventsToolData.length > 0) {
        let eventItems = this.eventsToolService.eventsToolData.filter(a=>
          (a.participants && a.participants.some(b=> b.id == contactID  &&
          !(
            b.isDeleted
            || b.indskr_reasons === EventRegistrationStatus.Cancelled
            || b.indskr_reasons === EventRegistrationStatus.Declined
            || b.indskr_reasons === EventRegistrationStatus['Cancelled late']
            || b.indskr_reasons === EventRegistrationStatus['No show']
          )))
          || (a.speakers && a.speakers.some(b=> b.id == contactID && !b.isDeleted))
        ).map(a=> {
          if(!this.dateTimeFormatService.isValidDate(a.scheduledStart)){
            a.scheduledStart = a.startDate;
          }
          if(!this.dateTimeFormatService.isValidDate(a.scheduledEnd)){
            a.scheduledEnd = a.endDate;
          }
          return a;
        }).sort((a, b) => {
          if (a.scheduledStart > b.scheduledStart) return -1;
          if (a.scheduledStart < b.scheduledStart) return 1;
          return 0;
        }).slice(0, sliceEnd);
        if (eventItems && eventItems.length > 0) {
          allItems.push(...eventItems);
        }
      }
    } catch (error) {
      console.error('Error getting events for timeline', error);
    }

    // Customer Survey
    this.customerAssessService.allContactSurveys;
    try {
      let surveyItems = [];
      // if(this.customerAssessService.allContactSurveys && this.customerAssessService.allContactSurveys.length > 0){
      //   surveyItems = this.customerAssessService.allContactSurveys.sort((a,b)=> {
      //     if (a.indskr_fromdate > b.indskr_fromdate) return 1;
      //     if (a.indskr_fromdate < b.indskr_fromdate) return -1;
      //     return 0;
      //   }).slice(0, sliceEnd).map(a=> {
      //     if(a.indskr_fromdate){
      //       a['scheduledStart'] = new Date(a.indskr_fromdate);
      //     }
      //     return a;
      //   });
      // }
      let surveysByContactId: any = this.customerAssessService.contactSurveysForTimeline.filter(survey => survey.surveyStatus != SurveyStatus.SAVED) || [];
      if (!isEmpty(surveysByContactId)) {
        let groupedResponsesByDate: any = [];
        groupedResponsesByDate = groupBy(surveysByContactId, 'indskr_assessmentdate');
        groupedResponsesByDate = values(groupedResponsesByDate);

        groupedResponsesByDate.forEach((resp) => {
          let activity: any = {};

          const templateId: string = resp[0]['_indskr_template_value'];
          const foundTemplate: AssessmentTemplate = this.customerAssessService.surveytemplates.find(survey => survey.indskr_assessmenttemplateid == templateId);

          let surveyFrequency: string = foundTemplate['indskr_surveyfrequency'] ? foundTemplate['indskr_surveyfrequency'] == SurveyFrequency.ONCE ? this.translate.instant("ONE_TIME") : this.translate.instant("RECURRING") : '';
          activity['type'] = ActivityType.CustomerSurvey;
          activity['subject'] = resp[0]['indskr_name'] || '';
          activity['assessmentId'] = resp[0]['indskr_customerassessmentid'];
          activity['scheduledStart'] = resp[0]['indskr_assessmentdate'];
          activity['surveyFrequency'] = surveyFrequency;
          activity['surveyedBy'] = resp[0]['_modifiedby_value_Formatted'] || '';
          activity['templateId'] = templateId;
          // activity['rawData'] = resp;
          surveyItems.push(activity);
        });
      }
      surveyItems = surveyItems.sort((a, b) => {
        if (a.scheduledStart > b.scheduledStart) return -1;
        if (a.scheduledStart < b.scheduledStart) return 1;
        return 0;
      }).slice(0, sliceEnd);
      allItems.push(...surveyItems);
    } catch (error) {
      console.error('Error getting surveys for timeline', error);
    }

    // Consent Activity
    try {
      let consenctActivities = this.consentService.allConsentActivitiesWithProductsAndEmails;
      if (consenctActivities && consenctActivities.length > 0 && this.contactService.contactInformation) {
        consenctActivities = consenctActivities.filter((activity) => activity.contactId == contactID);
        let consentItems = [];
        consenctActivities?.forEach((conAct) => {
          let activity: any = cloneDeep(conAct);
          let secondaryText = [conAct.indskr_productname, conAct.emailAddress, conAct.indskr_phone, conAct.indskr_addressname].filter(Boolean).join(', ');
          let optInOutSourceName: string = '';
          
          if (conAct.indskr_type == 100000000 && conAct.indskr_optinsource_Formatted) {
            optInOutSourceName = conAct.indskr_optinsource_Formatted;
          } else if (conAct.indskr_type == 100000001 && conAct.indskr_optoutsource_Formatted) {
            optInOutSourceName = conAct.indskr_optoutsource_Formatted
          }
          
          const consentSourceTypeName = conAct.consentSourceName || '';
          let consentSourceText: string = '';

          if (optInOutSourceName && consentSourceTypeName) {
            consentSourceText = optInOutSourceName + ':' + consentSourceTypeName;
          } else if (optInOutSourceName) {
            consentSourceText = optInOutSourceName;
          } else if (consentSourceTypeName) {
            consentSourceText = consentSourceTypeName;
          }

          activity['type'] = ActivityType.ConsentActivity;
          activity['subject'] = conAct.indskr_name;
          activity['source'] = consentSourceText;
          activity['scheduledStart'] = new Date(conAct.indskr_activitydate ?? conAct.createdon);
          activity['ownerId'] = conAct._createdby_value;
          activity['secondaryText'] = secondaryText;
          consentItems.push(activity);
        })
        if (consentItems && consentItems.length > 0) {
          consentItems = consentItems.sort((a, b) => {
            if (a.scheduledStart > b.scheduledStart) return -1;
            if (a.scheduledStart < b.scheduledStart) return 1;
            return 0;
          }).slice(0, sliceEnd);
          allItems.push(...consentItems);
        }
      }
    } catch (error) {
      console.error('Error getting consents for timeline', error);
    }

    // Sample Delivery Requests — offline feed parity (device-wide rep cache).
    try {
      if (this.authService.hasFeatureAction(FeatureActionsMap.SAMPLE_DELIVERY_REQUESTS)) {
        const sdrItems = this.sdrService.getRepSdrsForContact(contactID)
          .map((sdr) => ({
            ...sdr,
            type: ActivityType.SampleDeliveryRequest,
            scheduledStart: sdr.createdOn,
            subject: sdr.title,
          }))
          .sort((a, b) => {
            if (a.scheduledStart > b.scheduledStart) return -1;
            if (a.scheduledStart < b.scheduledStart) return 1;
            return 0;
          })
          .slice(0, sliceEnd);
        allItems.push(...sdrItems);
      }
    } catch (error) {
      console.error('Error getting SDRs for timeline', error);
    }

    try {
      if (allItems && allItems.length > 0) {
        allItems = allItems.sort((a, b) => {
          if (a.scheduledStart > b.scheduledStart) return -1;
          if (a.scheduledStart < b.scheduledStart) return 1;
          return 0;
        }).slice(0, sliceEnd);
      }
    } catch (error) {
      console.error('Error sorting timeline activities', error);
    }

    // Were getting fetched through online calls only
    // Website Access Logs
    // Customer Journey Appointment
    // Customer Journey Phonecalls
    if(allItems.length > 0){
      for(let i=0;i<allItems.length;i++){
        const item = allItems[i];
        if(item instanceof AppointmentActivity){
          const activity = await this.activityDataService.getNewDetailAppendedAppointmentActivityInstanceFromLocalDB(item.ID);
          result.push(activity);
        }else if(item instanceof PhoneActivity){
          const activity = await this.activityDataService.getNewDetailAppendedPhoneCallActivityInstanceFromLocalDB(item.ID);
          result.push(activity);
        }else{
          result.push(item);
        }
      }
    }
    return allItems;
  }

  public openDetails(ev) {
    if(this.readOnly) return;
    let item:any = this.timelineItems.find(a=> ev && a.id == ev.value);
    if (item) {
      let selActivity = item.refObject;
      //prevent navigation issue
      if ((this.contactService.accessedContactListFrom === PageName.AccountDetailsComponent && this.contactService.contactPageMode === ComponentViewMode.READONLY)
        || this.contactService.contactPageMode === ComponentViewMode.PREVIEW
        || this.dynamicFormService.isOpenedAffiliatedContactOnAccount
        || this.dynamicFormService.isOpenedAffiliatedContactOnContact
        || this.emailService.viewType === EmailViewType.CREATE_FROM_MEETING
        || this.caseService.accessedFrom == AccesingMode.INMEETING
        || (this.modalView && this.sampleService.inMeetingAllocationActivity)
        || selActivity.type == ActivityType.ConsentActivity) {
        // Activity cannot be opened to avoid navigation loop
        return;
      }
      this.uiService.showNewActivity = false;
      this.uiService.activeView = 'ActivitySkeleton';
      setTimeout(() => {
        this.displayActivityDetails(selActivity as Activity);
      }, 0);
    }
  }

  async displayActivityDetails(activity: Activity) {
    let foundActivity = this.activityService.getActivityByID(activity.ID);
    if (activity.type == ActivityType.Sample) {
      if (foundActivity) {
        this.activityService.selected = foundActivity;
      } else {
        await this.activityDataService.updateActivityDetails(activity);
      }
      this.sampleService.samplingDetailsViewMode = SamplingDetailsViewMode.VIEW_DETAILS;
      this.uiService.showNewActivity = false;
      this.uiService.activeView = 'Sample';
      this.uiService.prevView = 'contactDetails';
      if(this.navService.getCurrentMasterPageName() === PageName.ScientificActivityPage){
        this.uiService.showCancelDoneOnActivityDetails = false;
      } else if (this.navService.getCurrentMasterPageName() == PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPagePlanTabSelectedPlan ==='scientificPlans') {
        this.uiService.showCancelDoneOnActivityDetails = false;
        this.uiService.activeView = 'ActivitiesPageRightPaneNav';
      }
      this.navService.pushChildNavPageWithPageTracking(PageName.NewSampleActivityComponent, PageName.NewSampleActivityComponent, PageName.ContactPageComponent, { from: PageName.ContactDetailsComponent });
    } else if (activity.type == ActivityType.Email) {
      if(this.device.isOffline) {
        this.activityService.selectedActivity = (foundActivity) ? foundActivity : activity;
      }
      await this.activityDataService.updateActivityDetails(foundActivity ? foundActivity : activity).then(() => {
        this.emailService.viewType = EmailViewType.FROM_CONTACT_TIMELINE;
        this.uiService.showNewActivity = false;
        this.emailService.setCurrentEmail(this.emailService.selectedActivity);
        if(this.navService.getCurrentMasterPageName() !== PageName.ContactPageComponent){
          this.uiService.activeView = 'Email';
        }
        this.uiService.prevView = 'contactDetails';
        if(this.navService.getCurrentMasterPageName() === PageName.ScientificActivityPage){
          this.uiService.showCancelDoneOnActivityDetails = false;
        }
        if (this.navService.getCurrentMasterPageName() == PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPagePlanTabSelectedPlan ==='scientificPlans') {
          this.uiService.showCancelDoneOnActivityDetails = false;
          this.uiService.activeView = 'ActivitiesPageRightPaneNav';
        }
        if(!this.dateTimeFormatService.isValidDate(this.emailService.selectedActivity.scheduledStart) || !this.dateTimeFormatService.isValidDate(this.emailService.selectedActivity.scheduledEnd)){
          // OMNI-27162: Currently contact timeline activities fetch service is returning activities created on dynamics for customer enquiry
          // Those activities doesn't have any scheduled start and end time attribute value so added this check to prevent the UI to break
          // In future it will be handled on service end to omit those activities from response
            return;
        }
        this.navService.pushChildNavPageWithPageTracking(PageName.EmailDetailsPageComponent, PageName.EmailDetailsPageComponent, PageName.ContactPageComponent, { from: PageName.ContactDetailsComponent });

      }).catch(() => {
        // Failed to load email activity
      });
    } else if (activity.type == ActivityType.CaseIntake) {
      let iCase: CaseActivity;
      if (!this.device.isOffline && !activity.ID.includes('offline')) {
        this.uiService.displayLoader();
        await this.caseDataService.findCaseById(activity.ID).then(
          async res => {
            if (res) {
              for (let key in res) {
                if (key.charAt(0) === "_") {
                  var a = key.substring(1, key.length);
                  res[a] = res[key];
                  delete res[key];
                }
              }
              iCase = new CaseActivity(res);
            }
            this.uiService.dismissLoader();
          }).catch(() => {
            this.uiService.dismissLoader();
            iCase = activity as CaseActivity;
          });
      } else {
        iCase = activity as CaseActivity;
      }
      if(!isEmpty(iCase)) {
        iCase = await this.caseService.reInitDataDependency(iCase);
        this.activityService.selectedActivity = iCase;
        this.caseService.assignSelectedCase(iCase);
        this.caseService.accessedFrom = AccesingMode.CONTACT_TIMELINE;
        this.uiService.showNewActivity = false;
        this.uiService.activeView = 'ContactPageRightPaneNav';
        this.uiService.prevView = 'contactDetails';
        if (this.navService.getCurrentMasterPageName() === PageName.ScientificActivityPage) {
          this.uiService.showCancelDoneOnActivityDetails = false;
        }
        else if (this.navService.getCurrentMasterPageName() == PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPagePlanTabSelectedPlan === 'scientificPlans') {
          this.uiService.showCancelDoneOnActivityDetails = false;
          this.uiService.activeView = 'ActivitiesPageRightPaneNav';
        }
        this.navService.pushChildNavPageWithPageTracking(PageName.CaseManagementDetailComponent, PageName.CaseManagementDetailComponent, PageName.ContactPageComponent, { from: PageName.ContactDetailsComponent });
      } else {
        this.notificationService.notify(this.translate.instant('OM_WAS_A_PROBLEM_CONTACT_ADMINISTRATOR'), 'Account Feed', 'top', ToastStyle.DANGER);
      }
    } else if (activity.type == ActivityType.PhoneCall) {
      this.activityService.prevSelectedActivity = this.activityService.selectedActivity;
      // await this.activityDataService.updateActivityDetails(foundActivity ? foundActivity : activity);
      await this.uiService.displayLoader();
      if(!this.device.isOffline) {
        await this.activityDataService.getPhonecallActivityByIdOnline(activity.ID, activity.scheduledStart.getTime().toString(), activity.scheduledEnd.getTime().toString(), activity.scheduledStart.getTime().toString()).then(async (response) => {
          activity = new PhoneActivity(response);
          await this.activityDataService.updateActivityForConfigField(activity, response, ActivityType.PhoneCall);
          await this.activityDataService._appendPhoneCallDetailsToActivity(activity, response, false)
          this.activityDataService.activityDetailsLoaded = true;
        })
      }else {
        const activityDoc = await this.activityDataService.getOfflineActivityDocByKey(DB_KEY_PREFIXES.PHONE_CALL_ACTIVITY+activity.ID);
        if(activityDoc){
          activity = new PhoneActivity(activityDoc);
          await this.activityDataService.updateActivityForConfigField(activity, activityDoc, ActivityType.PhoneCall);
          await this.activityDataService._appendPhoneCallDetailsToActivity(activity, activityDoc);
          this.activityDataService.activityDetailsLoaded = true;
        }
      }
      //In case of date value as string type, need to set date type. it happened in offline mode
      if(!isEmpty(activity.scheduledStart)) activity.scheduledStart = new Date(activity.scheduledStart);
      if(!isEmpty(activity.scheduledEnd)) activity.scheduledEnd = new Date(activity.scheduledEnd);

      if(!this.dateTimeFormatService.isValidDate(activity.scheduledStart) || !this.dateTimeFormatService.isValidDate(activity.scheduledEnd)){
      // OMNI-27162: Currently contact timeline activities fetch service is returning activities created on dynamics for customer enquiry
      // Those activities doesn't have any scheduled start and end time attribute value so added this check to prevent the UI to break
      // In future it will be handled on service end to omit those activities from response
        await this.uiService.dismissLoader();
        return;
      }
      await this.uiService.dismissLoader();
      this.activityService.selected = activity;
      this.uiService.activeView = 'phoneCallTimelineDetails';
      this.uiService.prevView = 'contactDetails';
      if (this.activityService.selectedActivity) {
        if(this.navService.getCurrentMasterPageName() === PageName.ScientificActivityPage){
          this.uiService.showCancelDoneOnActivityDetails = false;
        }
        if (this.navService.getCurrentMasterPageName() == PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPagePlanTabSelectedPlan ==='scientificPlans') {
          this.uiService.showCancelDoneOnActivityDetails = false;
          this.uiService.activeView = 'ActivitiesPageRightPaneNav';
        }
        this.navService.pushChildNavPageWithPageTracking(PageName.PhoneCallDetailsComponent, PageName.PhoneCallDetailsComponent, PageName.ContactPageComponent, { from: PageName.ContactDetailsComponent });
        this.footerService.initButtons(FooterViews.PHONE_CALL);
      }
    } else if (activity.type == ActivityType.SurgeryOrder) {
      let foundActivity = this.activityService.getActivityByID(activity.ID);
      if(foundActivity){
        this.activityService.selectedActivity = foundActivity;
      }else{
        this.uiService.displayLoader();
        foundActivity = await this.activityDataService.getRealTimeActivityDetails(activity);
        this.uiService.dismissLoader();
      }
      this.activityService.selectedActivity = (foundActivity) ? foundActivity : activity;
      this.uiService.activeView = 'ContactPageRightPaneNav';
      this.uiService.showNewActivity = false;
      this.navService.pushChildNavPageWithPageTracking(PageName.SurgeryOrderDetailsComponent, PageName.SurgeryOrderDetailsComponent, PageName.ContactPageComponent, { from: 'ContactTimeline', activity: this.activityService.selectedActivity });
      this.footerService.initButtons(FooterViews.SURGERY_ORDER_ACTIVITY);
    } else if (activity.type == ActivityType.Event || activity instanceof EventRegistration || activity instanceof EventActivity) {
      if (activity instanceof EventRegistration) {
        activity.ID = activity.eventId;
      }
      const eventsToolData = this.eventsToolService.eventsToolData;
      const foundEvent = eventsToolData.find(e=> {
        if(e.ID) {
          return e.ID === activity.ID;
        }else if (e.offlineId) {
          return e.offlineId === activity.offlineId;
        }else {
          return false;
        }
      });
      if(!isEmpty(foundEvent)) {
        activity = foundEvent;
        this.eventsToolService.selectedEventOnEventsTool = foundEvent;
      }else {
        return;
      }
      if(!this.device.isOffline) {
        this.uiService.displayLoader();
        await this.eventsToolDataService.fetchEventRealTimeDetails(activity as EventActivity).then((updatedEvent: EventActivity) => {
          activity = updatedEvent;
          this.uiService.dismissLoader();
        }).catch(() => {
          this.uiService.dismissLoader();
        });
      }
      this.activityService.prevSelectedActivity = this.activityService.selectedActivity;
      this.activityService.selectedActivity = activity;
      this.navService.pushChildNavPageWithPageTracking(PageName.EventDetailsPageComponent, PageName.EventDetailsPageComponent, PageName.ContactPageComponent, {
        from: 'ContactTimeline', event: this.activityService.selectedActivity,
      });
      this.eventsToolService.setSelectedEventUpdates(this.activityService.selectedActivity as EventActivity);
      this.footerService.initButtons(FooterViews.EVENTS_DETAILS);
    } else if (activity.type == ActivityType.CustomerSurvey) {
      if(this.device.isOffline) {
        this.notificationService.notify(this.translate.instant("SURVEY_ACTIVITIES_NOTIFY_ONLINE"), "survey-activities", "top", ToastStyle.DANGER, 3000, true);
        return;
      }
      if(!isEmpty(activity)) {
        this.openSubmittedSurveyDetails(activity);
      }
    } else if (activity.type === ActivityType.SampleDeliveryRequest) {
      this.navService.pushChildNavPageWithPageTracking(
        PageName.SampleDeliveryRequestDetailComponent,
        PageName.SampleDeliveryRequestDetailComponent,
        PageName.ContactPageComponent,
        { sdr: activity },
      );
    } else if (activity.type == ActivityType.Appointment) {
      this.activityService.prevSelectedActivity = this.activityService.selectedActivity;
      this.activityService.selected = (foundActivity) ? foundActivity : activity;
      this.uiService.showNewActivity = false;
      this.activityService.prevSelectedActivityOnTimeline = cloneDeep(this.activityService.selectedActivity);
      this.uiService.prevView = 'contactDetails';
      this.uiService.showCancelDoneOnActivityDetails = false;
      await this.activityDataService.updateActivityDetails(foundActivity ? foundActivity : activity);
      this.uiService.activeView = 'ContactPageRightPaneNav';
      if(!isEmpty(this.contactService.contactInformation)) {
        this.contactService.selectedContactOnTimeline = this.contactService.contactInformation;
      }
      // A non-owner viewing another rep's open meeting from the contact timeline must be
      // read-only. Position overlap is not the right criterion — two reps can share the
      // same position (both mapped to the contact) without having any right to edit each
      // other's meetings. FULL_ACCESS co-visitor exceptions are handled downstream in
      // enableReadonlyViewForMeetings, which guards against isDiffPosition blocking them.
      this.activityService.updateSelectedActivityProps({
        isDiffPosition: activity.meetingOwnerId !== this.authService.user.systemUserID
          && activity.state !== MeetingActivityState.Completed
      });
      this.eventService.publish('activities:appConfigFields');
      if (this.activityService.selectedActivity) {
        if(this.navService.getCurrentMasterPageName() === PageName.ScientificActivityPage){
          await this.navService.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.ContactPageComponent, { from: 'ScientificActivityPage', childFrom: PageName.ContactDetailsComponent });
        }
        else if (this.navService.getCurrentMasterPageName() == PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPagePlanTabSelectedPlan ==='scientificPlans') {
          this.uiService.activeView = 'ActivitiesPageRightPaneNav';
          await this.navService.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.ContactPageComponent, { from: 'ScientificActivityPage', childFrom: PageName.ContactDetailsComponent });
        } else {
          await this.navService.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.ContactPageComponent, { from: PageName.ContactTimelineComponent });
        }
        this.eventService.publish('detectChangesOnActivityDetails', true); // To triger angular change detection manually
        this.activityService.updateSelectedActivityProps({ accessedFrom: PageName.ContactTimelineComponent });
        this.footerService.initButtons(FooterViews.Activities);
      }
    }
  }

  public async openSubmittedSurveyDetails(survey: any) {
    if(this.device.isOffline) {
      this.notificationService.notify(this.translate.instant("SURVEY_ACTIVITIES_NOTIFY_ONLINE"), "contact-timeline", "top", ToastStyle.DANGER, 3000, true);
      return;
    }
    //check selected survey tempalte id
    const filteredSurveyList = this.customerAssessService.surveytemplates.filter(template => template.indskr_type == TemplateType.SURVEY);
    const templateId: string = survey['templateId'];
    const foundTemplate: AssessmentTemplate = filteredSurveyList.find(survey=> survey.indskr_assessmenttemplateid == templateId);
    this.customerSurveyService.setCurrentSurvey(foundTemplate);
    try {
      await this.navService.pushChildNavPageWithPageTracking(PageName.SurveyDetailsComponent, PageName.SurveyDetailsComponent, PageName.ContactDetailsComponent, { appointmentId: '', from: PageName.ContactDetailsComponent }).then(async()=>{
        this.navService.setChildNavRightPaneView(true);
        this.uiService.dismissLoader();
        this.customerSurveyService.selectedContactForSurvey = this.contactService.contactInformation;
        try {
          //map survey based on survey responses
          this.uiService.displayLoader;
          const responseData = await this.customerAssessService.fetchContactSurveyForDetails(survey, 'contact');
          if(!isEmpty(responseData)) {
            const formattedSurvey: CustomerAssessment = await this.customerAssessService.mapCustomerSurveyRespForTimeline(responseData);
            if (!isEmpty(formattedSurvey)) {
              this.customerSurveyService.setSurveyPreviewMode(true, formattedSurvey, 'timeline');
            }
          }
          this.uiService.dismissLoader();
        } catch (error) {
          console.error('Error opening survey details from timeline', error);
          this.uiService.dismissLoader();
        }
      });
    } catch(error) {
      console.error('Failed to open survey', error);
      this.uiService.dismissLoader();
    }
  }

  //  online timeline data //

  private _onlineTimelineFetchPromise: Promise<void> = null;

  private initOnlineTimelineData(): Promise<void> {
    if (this._onlineTimelineFetchPromise) {
      return this._onlineTimelineFetchPromise;
    }
    this._onlineTimelineFetchPromise = this._fetchOnlineTimelineData().finally(() => {
      this._onlineTimelineFetchPromise = null;
    });
    return this._onlineTimelineFetchPromise;
  }

  private async _fetchOnlineTimelineData() {
    try {
      this.isDataLoading = true;
      const contactId = this.contactService.contactInformation.ID;
      await this.contactService.removeContactActivitiesTimelineDB(contactId);
      await this.fetchContactTimeline();
      await this._getTimelineActivities();
    } catch (error) {
      console.error('Error initializing timeline data:', error);
    } finally {
      this.isDataLoading = false;
      this.cd.markForCheck();
    }
  }

  async fetchContactTimeline() {
    const featureFlags = this.getFeatureFlags();
    const page = 1;
    try {
      await this.contactDataService.getContactActivitiesForTimeline(this.contactService.contactInformation, page, this.pageSize);

      if (this.device.isOffline) {
        this.contactService.contactInformation.sdrActivities = [];
        return;
      }

      const contactInfo = this.contactService.contactInformation;
      if (!contactInfo) {
        return;
      }

      // Each of these writes to its own distinct field on contactInfo (events, website
      // logs, journeys, survey, SDRs), so they have no ordering dependency on each other.
      await Promise.all([
        this.fetchCustomerJourneyData(featureFlags.customerJourney, contactInfo),
        this.contactDataService.getContactWebsiteAccessLogsTimeline(contactInfo),
        this.fetchEventData(featureFlags, contactInfo),
        this.fetchSurveyData(featureFlags.customerSurvey, contactInfo),
        this.customer360UIService.loadSdrsForContact()
      ]);

    } catch (err) {
      console.error('Error fetching contact timeline', err);
    }
  }

  private getFeatureFlags() {
    return {
      customerEvents: this.authService.hasFeatureAction(FeatureActionsMap.EVENT_REGISTRATION) || this.authService.user.eventTimeLine,
      eventTool: this.authService.hasFeatureAction(FeatureActionsMap.EVENT_TOOL) || this.authService.user.eventTimeLine,
      customerJourney: this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER_JOURNEY_TIMELINE),
      customerSurvey: this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER_SURVEY)
    };
  }

  private async fetchCustomerJourneyData(isEnabled: boolean, contactInfo: any) {
    if (isEnabled) {
      await Promise.all([
        this.contactDataService.getCustomerJourneysForTimeline(contactInfo),
        this.contactDataService.getCustomerJourneysRealtimeMarketingEmailForTimeline(contactInfo)
      ]);
    } else {
      this.contactDataService.mapEmptyCustomerJourneysTimeline(contactInfo);
    }
  }

  private async fetchEventData(featureFlags: any, contactInfo: any) {
    if (isEmpty(contactInfo)) {
      return;
    }

    await Promise.all([
      this.fetchCustomerEventData(featureFlags.customerEvents, contactInfo),
      this.fetchEventToolData(featureFlags.eventTool, contactInfo)
    ]);
  }

  private async fetchCustomerEventData(isEnabled: boolean, contactInfo: any) {
    if (!isEnabled) {
      this.contactService.isContactDetailsLoaded = true;
      return;
    }

    try {
      // Registrations and speaker-engagement events write to separate contact fields
      // (eventsAndRegistrationsByContact / eventsSpeakerEngagementByContact).
      await Promise.all([
        this.customerEventDataService.getContactEventTimeline(contactInfo),
        this.customerEventDataService.getContactSpeakerEngagementEventTimeline(contactInfo)
      ]);
      if (contactInfo.eventsAndRegistrationsByContact) {
        this.contactService.isContactDetailsLoaded = true;
      }
    } catch (err) {
      console.error('Error fetching customer event timeline', err);
    }
  }

  private async fetchEventToolData(isEnabled: boolean, contactInfo: any) {
    if (!isEnabled) {
      return;
    }

    try {
      // Checked-in and completed events write to separate contact fields
      // (eventsCheckInByContact / eventsCompletedByContact).
      const tasks = [this.customerEventDataService.getContactCheckedInEventTimeline(contactInfo, this.pageSize)];
      if (this.authService.hasFeatureAction(FeatureActionsMap.EVENT_TOOL)) {
        tasks.push(this.customerEventDataService.getContactCompletedEventTimeline(contactInfo));
      }
      await Promise.all(tasks);
    } catch (err) {
      console.error('Error fetching event tool timeline', err);
    }
  }

  private async fetchSurveyData(isEnabled: boolean, contactInfo: any) {
    if (isEnabled && !isEmpty(contactInfo)) {
      await this.customerAssessService.getSurveysForTimeline(contactInfo.ID, SurveyCategory.CONTACT);
    }
  }

  private async _getTimelineActivities() {
    // Get feature flags once
    const featureFlags = {
      events: this.authService.hasFeatureAction(FeatureActionsMap.EVENT_REGISTRATION) || this.authService.user.eventTimeLine,
      eventTool: this.authService.hasFeatureAction(FeatureActionsMap.EVENT_TOOL) || this.authService.user.eventTimeLine,
      customerJourney: this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER_JOURNEY_TIMELINE),
      customerSurvey: this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER_SURVEY)
    };

    // Build timeline items in one pass
    let items = this.customer360UIService.combineEventsAndActivities([]).concat(this.customer360UIService.combineConsentsAndActivities([]));

    if (featureFlags.customerSurvey) {
      items = items.concat(this.customer360UIService.combineSurveysAndActivities([]));
    }

    if (featureFlags.customerJourney) {
      items = items.concat(this.customer360UIService.combineCustomerJourneyAndActivities([]));
    }

    if (!this.device.isOffline) {
      items = items.concat(this.customer360UIService.combineSdrsAndActivities([]));
    }

    // A single item with an unparseable scheduledStart (e.g. a malformed email activity
    // date) makes new Date(...).getTime() return NaN, and NaN poisons every comparison
    // touching that item. Array.prototype.sort doesn't guarantee a correct result once the
    // comparator stops being consistent — engines merge pre-existing runs assuming a valid
    // partial order, so one bad item corrupts the whole merge: each type's own items stay
    // sorted relative to each other, but the different types never get interleaved by real
    // date. That's why SampleDeliveryRequest items from today ended up positioned after
    // months-old emails and got cut off entirely by the pageSize slice below. Explicitly
    // treat invalid dates as "oldest" so they never break the comparator's consistency.
    items.sort((a, b) => {
      const aTime = new Date(a.scheduledStart).getTime();
      const bTime = new Date(b.scheduledStart).getTime();
      const aValid = !isNaN(aTime);
      const bValid = !isNaN(bTime);
      if (!aValid && !bValid) return 0;
      if (!aValid) return 1;
      if (!bValid) return -1;
      return bTime - aTime;
    });

    this.timelineItems = await this._getTimelineItemViewForActivities(items.slice(0, this.pageSize));
  }

  private async _getTimelineItemViewForActivities(activities: Array<any>, id?): Promise<TimeLineItem[]> {
    let itemsView: Array<TimeLineItem> = [];
    if (activities && activities.length > 0) {
      activities.forEach(item => {
        let activity;
        if (item.type == ActivityType.Event) {
          activity = this.eventsToolService.getEventDetailsbyId(item.eventId);
          if (activity) {
            activity.type = ActivityType.Event;
            if (!this.dateTimeFormatService.isValidDate(activity.scheduledStart)) {
              activity.scheduledStart = item.scheduledStart;
            }
          }
        }
        let view = this.customer360UIService.getViewForJourneyItem(false, activity ? activity : item, id);
        if (view) {
          if (item.type == ActivityType.Event && !activity || this.contactService.isContactInGlobalSearch(this.contactService.contactInformation)) {
            view.disableEndArrow = true;
          }
          itemsView.push(view);
        }
      })
    }
    return itemsView;
  }

  // private combineEventsAndActivities(items: any) {
  //   const isCustomerEventsEnabled = this.authService.hasFeatureAction(FeatureActionsMap.EVENT_REGISTRATION) || this.authService.user.eventTimeLine;
  //   const isEventToolfeatureAction = this.authService.hasFeatureAction(FeatureActionsMap.EVENT_TOOL) || this.authService.user.eventTimeLine;

  //   const {
  //     activitesTimeline,
  //     websiteAccessLogs,
  //     eventsAndRegistrationsByContact,
  //     eventsCheckInByContact,
  //     eventsCompletedByContact
  //   } = this.contactService.contactInformation || {};

  //   if (activitesTimeline?.length) {
  //     items = [...activitesTimeline];
  //   }

  //   if (websiteAccessLogs) {
  //     websiteAccessLogs.forEach(er => {
  //       er.type = ActivityType.WebsiteAccess;
  //       er['scheduledStart'] = er.accessDateTime;
  //       if (this.authService.user.customNotifications) {
  //         items.push(er);
  //       }
  //     });
  //   }
  //   //Combining events with activities
  //   if (isCustomerEventsEnabled) {
  //     if (eventsAndRegistrationsByContact) {
  //       eventsAndRegistrationsByContact.forEach(er => {
  //         er.type = ActivityType.Event;
  //         items.push(er);
  //       });
  //     }
  //   }

  //   if (isEventToolfeatureAction) {
  //     if (eventsCheckInByContact) {
  //       eventsCheckInByContact.forEach(er => {
  //         er.type = ActivityType.Event;
  //         er['scheduledStart'] = er.checkinTime ? er.checkinTime : er.createdOn;
  //         items.push(er);
  //       });
  //     }
  //     if (eventsCompletedByContact) {
  //       eventsCompletedByContact.forEach(er => {
  //         er.type = ActivityType.Event;
  //         er['scheduledStart'] = er.startDate;
  //         items.push(er);
  //       });
  //     }
  //   }

  //   return items;
  // }

  // private combineConsentsAndActivities(items: any) {
  //   const contactId = this.contactService.contactInformation?.ID;
  //   if (!contactId) {
  //     return items;
  //   }

  //   const consentActivities = this.consentService.allConsentActivitiesWithProductsAndEmails?.filter(activity => activity.contactId === contactId);

  //   if (!consentActivities?.length) {
  //     return items;
  //   }

  //   consentActivities.forEach(conAct => {
  //     const secondaryText = [
  //       conAct.indskr_productname,
  //       conAct.emailAddress, 
  //       conAct.indskr_phone,
  //       conAct.indskr_addressname
  //     ].filter(Boolean).join(', ');

  //     let optInOutSourceName = '';
  //     if (conAct.indskr_type === 100000000) {
  //       optInOutSourceName = conAct.indskr_optinsource_Formatted;
  //     } else if (conAct.indskr_type === 100000001) {
  //       optInOutSourceName = conAct.indskr_optoutsource_Formatted;
  //     }

  //     const consentSourceTypeName = conAct.consentSourceName || '';
  //     const consentSourceText = [optInOutSourceName, consentSourceTypeName].filter(Boolean).join(':');

  //     items.push({
  //       ...conAct,
  //       type: ActivityType.ConsentActivity,
  //       subject: conAct.indskr_name,
  //       source: consentSourceText,
  //       scheduledStart: new Date(conAct.indskr_activitydate ?? conAct.createdon),
  //       ownerId: conAct._createdby_value,
  //       secondaryText
  //     });
  //   });

  //   return items;
  // }

  // private combineSurveysAndActivities(items: any) {
  //   const surveys = this.customerAssessService.contactSurveysForTimeline.filter(survey => survey.surveyStatus !== SurveyStatus.SAVED);

  //   if (isEmpty(surveys)) {
  //     return items;
  //   }

  //   const groupedByDate = values(groupBy(surveys, 'indskr_assessmentdate'));

  //   groupedByDate.forEach(responses => {
  //     const firstResponse = responses[0];
  //     const templateId = firstResponse['_indskr_template_value'];
  //     const template = this.customerAssessService.surveytemplates.find(survey => survey.indskr_assessmenttemplateid === templateId);

  //     let surveyFrequency = '';
  //     if (template?.['indskr_surveyfrequency']) {
  //       surveyFrequency = template['indskr_surveyfrequency'] === SurveyFrequency.ONCE 
  //         ? this.translate.instant("ONE_TIME") 
  //         : this.translate.instant("RECURRING");
  //     }

  //     const activity = {
  //       type: ActivityType.CustomerSurvey,
  //       subject: firstResponse['indskr_name'] || '',
  //       assessmentId: firstResponse['indskr_customerassessmentid'],
  //       scheduledStart: firstResponse['indskr_assessmentdate'],
  //       surveyFrequency,
  //       surveyedBy: firstResponse['_modifiedby_value_Formatted'] || '',
  //       templateId
  //     };

  //     items.push(activity);
  //   });

  //   return items;
  // }

  /**************************Customer Journey**************************/
  // private combineCustomerJourneyAndActivities(items: any) {
  //   if (this.contactService.contactInformation.customerJourneysTimeline) {
  //     this.contactService.contactInformation.customerJourneysTimeline.forEach((activity: Activity) => {
  //       if (activity.type === ActivityType.Appointment) {
  //         activity.type = ActivityType.CustomerJourneyAppointment;
  //         activity.scheduledStart = activity.journeyStart;
  //         activity.scheduledEnd = activity.journeyEnd;
  //       }
  //       else if (activity.type === ActivityType.PhoneCall) {
  //         activity.type = ActivityType.CustomerJourneyPhoneCall;
  //         activity.scheduledStart = activity.journeyStart;
  //         activity.scheduledEnd = activity.journeyEnd;
  //       }
  //       else if (activity.type === ActivityType.Email) {
  //         activity.type = ActivityType.CustomerJourneyEmail;
  //         activity.scheduledStart = activity.journeyStart;
  //         activity.scheduledEnd = activity.journeyEnd;
  //       }
  //       items.push(activity);
  //     });
  //   }
  //   return items;
  // }

  //  online timeline data //

}
